import axios from 'axios'

const getERC721TokenData = (url: string) => axios(url)

export default getERC721TokenData
